module.exports = "tr.td-data-table-row {\n  height: 140px; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/tecnicasterapeuticas/tecnicasterapeuticas.component.scss
// module id = ./src/app/consulta/tecnicasterapeuticas/tecnicasterapeuticas.component.scss
// module chunks = main